export default {
  methods: {
    // 自定义合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(String(item[column.property]).replace("%", "")));
        // 百分比
        const isPercent = data.some((item) => String(item[column.property]).includes("%"));
        if (!values.every((value) => isNaN(value))) {
          const sum = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Number(prev + curr);
            } else {
              return (prev);
            }
          }, 0).toFixed(2);
          sums[index] = isPercent ? sum + "%" : sum;
          if (column.property == "memberRateVal") {
            sums[index] = this.newMemberRateTotal;
          }
        } else {
          sums[index] = "-";
        }
      });
      return sums;
    },
    formatPercent(value) {
      if (value === null || value === undefined || value === "") return "-";
      const num = Number(value);
      if (isNaN(num)) return "-";
      return `${num.toFixed(2)}%`;
    },
    formatNumber(value) {
      if (value === null || value === undefined || value === "") return "-";
      const num = Number(value);
      if (isNaN(num)) return "-";
      // 是否整数
      const isInteger = Number.isInteger(num);
      const options = {
        minimumFractionDigits: isInteger ? 0 : 2,
        maximumFractionDigits: 2,
      };
      return num.toLocaleString("en-US", options);
    },
  },
}